import React from 'react';
export function BonusSection() {
  return <>
      <section className="py-20 bg-brand-dark border-t border-white/5" data-id="element-28">
        <div className="container mx-auto px-4 max-w-6xl" data-id="element-29">
          <div className="text-center mb-16" data-id="element-30">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-31">
              Apilamiento de Valor:{' '}
              <span className="text-brand-gold" data-id="element-32">Regalos Exclusivos</span>
            </h2>
            <p className="text-gray-400" data-id="element-33">
              Obtén esto GRATIS al asegurar tu acceso hoy.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-34">
            {/* Bonus 1 - Bebidas Detox */}
            <div className="glass-card rounded-xl overflow-hidden border border-white/10 group hover:border-brand-gold/50 transition duration-300 flex flex-col" data-id="element-35">
              <div className="relative bg-black p-6 flex justify-center" data-id="element-36">
                <div className="absolute top-4 left-4 bg-brand-gold text-black text-xs font-bold px-2 py-1 rounded uppercase z-10" data-id="element-37">
                  HOY GRATIS
                </div>
                <img src="https://i.postimg.cc/nrDgGmwD/Bono-1-con-portada-terminada.webp" alt="Bebidas Detox" className="h-64 object-contain group-hover:scale-110 transition duration-500" data-id="element-38" />
              </div>
              <div className="p-6 flex-grow flex flex-col" data-id="element-39">
                <h3 className="font-heading text-lg font-bold text-white mb-1" data-id="element-40">
                  Bebidas Detox
                </h3>
                <p className="text-brand-gold/80 text-sm font-medium italic mb-3" data-id="element-41">
                  Sanando desde el Interior
                </p>
                <ul className="text-sm text-gray-400 font-light mb-4 flex-grow space-y-3" data-id="element-42">
                  <li data-id="element-43">
                    <strong className="text-white" data-id="element-44">Shot de la Mañana:</strong>{' '}
                    Jugo de medio limón, 1 rodaja de jengibre y pizca de cúrcuma
                    en agua tibia. Tomar en ayunas para bajar la inflamación
                    sistémica.
                  </li>
                  <li data-id="element-45">
                    <strong className="text-white" data-id="element-46">Té de Romero:</strong> Una
                    taza por la tarde para regular la insulina y fortalecer la
                    raíz desde el flujo sanguíneo interno.
                  </li>
                </ul>
                <p className="text-brand-gold/60 text-sm font-semibold" data-id="element-47">
                  <span className="line-through text-gray-600 mr-2" data-id="element-48">
                    Valor USD27
                  </span>{' '}
                  GRATIS
                </p>
              </div>
            </div>

            {/* Bonus 2 - Protocolo Anti-Canas */}
            <div className="glass-card rounded-xl overflow-hidden border border-white/10 group hover:border-brand-gold/50 transition duration-300 flex flex-col" data-id="element-49">
              <div className="relative bg-black p-6 flex justify-center" data-id="element-50">
                <div className="absolute top-4 left-4 bg-brand-gold text-black text-xs font-bold px-2 py-1 rounded uppercase z-10" data-id="element-51">
                  HOY GRATIS
                </div>
                <img src="https://i.postimg.cc/CKr2y73r/Bono-2-con-portada-terminada.webp" alt="Protocolo Anti-Canas" className="h-64 object-contain group-hover:scale-110 transition duration-500" data-id="element-52" />
              </div>
              <div className="p-6 flex-grow flex flex-col" data-id="element-53">
                <h3 className="font-heading text-lg font-bold text-white mb-1" data-id="element-54">
                  Protocolo Anti-Canas
                </h3>
                <p className="text-brand-gold/80 text-sm font-medium italic mb-3" data-id="element-55">
                  Pigmentación Natural
                </p>
                <p className="text-sm text-gray-400 font-light mb-4 flex-grow" data-id="element-56">
                  Añade a tu tónico base 2 ramas de romero fresco y una
                  cucharada de té negro concentrado. Deja fermentar 48 horas en
                  oscuridad. Aplica esta mezcla en las zonas grises. El romero
                  reactiva los melanocitos mientras el té negro añade pigmento
                  natural sin químicos.
                </p>
                <p className="text-brand-gold/60 text-sm font-semibold" data-id="element-57">
                  <span className="line-through text-gray-600 mr-2" data-id="element-58">
                    Valor USD27
                  </span>{' '}
                  GRATIS
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="section-separator" data-id="element-59"></div>
    </>;
}